<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="getReportFiltered($event)"
></mt-filter>
<div
    class="report-container mt-4"
    *ngIf="hasData || tableConfig || message || systemError"
>
    <div class="header-container">
        <div class="header">
            <div class="float-left">
                <div class="title">
                    {{ "drillings" | lang | uppercase }}
                </div>
            </div>
            <div class="float-right" *ngIf="hasData">
                <app-button-icon
                    [image]="'download'"
                    [iconType]="'icon'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (clickHandler)="downloadExcel()"
                ></app-button-icon>
            </div>
        </div>
    </div>
    <div [ngClass]="{ 'body-container': !hideReport }">
        <!-- Message -->
        <div class="d-flex flex-row message" *ngIf="message">
            <img
                class="message-img"
                appImageSelector
                [imageType]="'icon'"
                alt="error-message"
                [imageKey]="'error-red'"
            />
            <span class="message-text">{{ message }}</span>
        </div>

        <app-system-error-message
            *ngIf="!!systemError"
            [message]="systemError"
        ></app-system-error-message>

        <div [hidden]="hideReport">
            <!--Container totalDepth and totalquantityDepth-->
            <div class="row">
                <div class="col-6">
                    <app-total-depth
                        [reportData]="reportData?.totalDepth"
                    ></app-total-depth>
                </div>
                <!--Table Summary Depth-->
                <div class="col-6">
                    <app-main-table
                        class="table-summary-drilling"
                        [tableConfig]="tableByMachine"
                    >
                    </app-main-table>
                </div>
            </div>
            <!--Table Details Depth-->
            <div class="row">
                <div class="col-12">
                    <app-main-table
                        class="table-drilling"
                        [tableConfig]="tableConfig"
                    ></app-main-table>
                </div>
            </div>
        </div>
    </div>
</div>
